import { deserializeXY } from "../serialization";
import type { PhysicalThing } from "../physicalThing";
import type { XY } from "../xy";
import { Squid } from "./squid";
import { AlbinoSquidCorpse } from "./albinoSquidCorpse";

export class AlbinoSquid extends Squid {
	static key = "AlbinoSquid";
	constructor(xy: XY) {
		super(xy);
	}

	generateCorpse(): PhysicalThing | null {
		return new AlbinoSquidCorpse(this.xy);
	}

	static deserialize(data: any): AlbinoSquid {
		const s = new AlbinoSquid(deserializeXY(data.xy));
		s.restoreMobFields(data);
		return s;
	}
}
